import { Box, IconButton, Stack, Typography } from "@mui/material";
import React from "react";
import MobileAppColorIcon from "../../icons/MobileAppColorIcon";

const IconLegendsBox = () => {
  return (
    <Stack padding="0 8px 8px" gap="8px">
      <Typography
        variant="subtitle1"
        fontSize="1.3rem"
        color="rgba(0, 0, 0, 0.87)"
      >
        Icon Legend
      </Typography>

      <Box display="flex" alignItems="flex-start" width="100%">
        <Box display="flex" alignItems="flex-start" width="50%" gap="4px">
          <Box padding="6px">
            <MobileAppColorIcon color="rgba(0, 0, 0, 0.38)" />
          </Box>
          <Stack>
            <Typography variant="caption" color="secondary">
              Mobile App Disabled
            </Typography>
            <Typography variant="caption" color="rgba(0, 0, 0, 0.87)">
              Not enrolled in any program{" "}
            </Typography>
          </Stack>
        </Box>
        <Box display="flex" alignItems="flex-start" width="50%" gap="4px">
          <Box padding="6px">
            <MobileAppColorIcon />
          </Box>
          <Stack>
            <Typography variant="caption" color="secondary">
              Never Logged In
            </Typography>
            <Typography variant="caption" color="rgba(0, 0, 0, 0.87)">
              Credentials sent but login pending{" "}
            </Typography>
          </Stack>
        </Box>
      </Box>

      <Box display="flex" alignItems="flex-start" width="100%">
        <Box display="flex" alignItems="flex-start" width="50%" gap="4px">
          <Box padding="6px">
            <MobileAppColorIcon color="#FF852D" />
          </Box>
          <Stack>
            <Typography variant="caption" color="secondary">
              Mobile App InActive
            </Typography>
            <Typography variant="caption" color="rgba(0, 0, 0, 0.87)">
              No readings in the last 7 days
            </Typography>
          </Stack>
        </Box>
        <Box display="flex" alignItems="flex-start" width="50%" gap="4px">
          <Box padding="6px">
            <MobileAppColorIcon color="#3DC583" />
          </Box>
          <Stack>
            <Typography variant="caption" color="secondary">
              Mobile App Active
            </Typography>
            <Typography variant="caption" color="rgba(0, 0, 0, 0.87)">
              Readings logged in the last 7 days
            </Typography>
          </Stack>
        </Box>
      </Box>
    </Stack>
  );
};

export default IconLegendsBox;
